/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentOAuthAppClientCredentials { 
    /**
     * Client Id for the related oauth app.
     */
    client_id?: string;
    /**
     * Secret key for the oauth app client credentials.
     */
    client_secret?: string;
    /**
     * A newly created Provider ID mapped to the Agent Resource ID in format: <res-type>-<res-id>.
     */
    provider_id?: string;
}

